/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Bm_Meta_DescInputs */

const en_fw_bm_meta_desc = /** @type {(inputs: Fw_Bm_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First-attempt verification rate of AI coding agents, measured on real tasks: by agent, by task tier and by criterion kind. Anonymous aggregates from Bystep's evidence log.`)
};

const id_fw_bm_meta_desc = /** @type {(inputs: Fw_Bm_Meta_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tingkat lolos verifikasi percobaan pertama agen coding AI, diukur dari task nyata: per agen, per tingkat task, dan per jenis kriteria. Agregat anonim dari log bukti Bystep.`)
};

/**
* | output |
* | --- |
* | "First-attempt verification rate of AI coding agents, measured on real tasks: by agent, by task tier and by criterion kind. Anonymous aggregates from Bystep's..." |
*
* @param {Fw_Bm_Meta_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_bm_meta_desc = /** @type {((inputs?: Fw_Bm_Meta_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Bm_Meta_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_bm_meta_desc(inputs)
	return en_fw_bm_meta_desc(inputs)
});